// extracted by mini-css-extract-plugin
export default {"loginContainer":"index_loginContainer__a3e7B"};